// case transform --------
/**
 * @param {string} str
 * @returns {string[]} */
export const splitWords = (str) =>
  (str.toUpperCase() === str ? str : str.replace(/([A-Z])/g, " $1"))
    .replace(/(_)/g, " ")
    .split(" ")
    .filter(Boolean);

/**
 * @param {string} str
 * @returns {string} */
export const toTitleCase = (str) =>
  splitWords(str)
    .map((x) => x.charAt(0).toUpperCase() + x.slice(1).toLowerCase())
    .join(" ");

/**
 * @param {string} str
 * @returns {string} */
export const toPascalCase = (str) => toTitleCase(str).replaceAll(" ", "");

/**
 * @param {string} str
 * @returns {string} */
export const toCamelCase = (str) =>
  str.charAt(0).toLowerCase() + toPascalCase(str).slice(1);

/**
 * @param {string} str
 * @returns {string} */
export const toSnakeCase = (str) => splitWords(str).join("_").toLowerCase();

/**
 * @param {string} str
 * @returns {string} */
export const toKebabCase = (str) => splitWords(str).join("-").toLowerCase();

// ---------------------
/**
 * @param {string} jsonString
 * @returns {boolean} */
export const isValidJSON = (jsonString) => {
  try {
    const obj = JSON.parse(jsonString);
    if (obj && typeof obj === "object") {
      return true;
    }
  } catch (e) {}
  return false;
};

/**
 * @param {Array.<any>} arr
 * @returns {Array.<any>} */
export const removeDuplicates = (arr) => {
  return [...new Set(arr)];
};

// --------------------
//use json.strinfy and typeof
/**
 * @param {any} resp
 * @returns {string} */
export const extractMessageFromResponse = (resp) =>
  resp?.message || resp?.detail?.message || resp?.detail?.msg || resp?.detail;

/**
 * @param {any} resp
 * @param {number} respStatus
 * @param {function} successCallback
 * @param {function} setMessage
 * @param {function} setSeverity
 * @param {function} setNotify
 * @returns
 */
export const showNotification = (
  resp,
  respStatus,
  successCallback,
  setMessage,
  setSeverity,
  setNotify
) => {
  let message = extractMessageFromResponse(resp);
  if (isValidJSON(message)) {
    message = JSON.stringify(message);
  }
  if (message?.length && typeof respStatus === "number") {
    setMessage(message);
    setSeverity(respStatus < 300 ? "success" : "error");
    setNotify(true);
    if (respStatus < 300) {
      successCallback();
    }
  }
};

/**
 * @param {any} url
 * @returns  */
export const downloadFileFromUrl = (url) => {
  let safeUrl;
  try {
    safeUrl = new URL(url, window.location.origin);
  } catch (e) {
    return;
  }
  // Only ever navigate to http(s) — blocks javascript:/data: URLs from
  // being assigned into href, which is what CodeQL's DOM-XSS check flags.
  if (safeUrl.protocol !== "http:" && safeUrl.protocol !== "https:") return;

  const link = document.createElement("a");
  link.href = safeUrl.href;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

/**
 *
 * @param {string} input
 * @param {number} multiplyingFactor
 * @returns {string} */
export const multiplyWithUnit = (input, multiplyingFactor) => {
  if (!input) return "";
  const num = parseFloat(input);
  const unit = input.replace(num.toString(), "");
  return `${num * multiplyingFactor}${unit}`;
};

/**
 * Subsequence based fuzzy match, tolerant of missing characters in between.
 * Returns a score (lower is a tighter match) or null when the query does not match.
 * @param {string} text
 * @param {string} query
 * @returns {number|null} */
export const fuzzyMatchScore = (text, query) => {
  const haystack = (text || "").toLowerCase();
  const needle = (query || "").trim().toLowerCase();
  if (!needle) return 0;

  let score = 0;
  let prevIdx = -1;
  for (const char of needle) {
    const idx = haystack.indexOf(char, prevIdx + 1);
    if (idx === -1) return null;
    score += prevIdx === -1 ? idx : idx - prevIdx - 1;
    prevIdx = idx;
  }
  return score;
};

/**
 * @param {string[]} permissionList
 * @param {string} resource
 * @returns {boolean}
 */
export const permissionListIncludes = (permissionList, resource) => {
  return permissionList.includes(resource) || permissionList.includes("*");
};
